module.exports = __webpack_public_path__ + "img/Fertigbau Holz.9d6bf464.svg";